import Config from 'services/config/config';
import { SHOW_HIDE_TOAST } from 'services/redux/sales/appNotifications/type';
import { store } from 'services/redux/store';
import callWebService, { callTypes } from 'services/utils/networks/network';
import { MEETING_HISTORY, POC_LIST_DROPDOWN, MEETING_BY_ID } from './type';

export const getMeetingList = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.meetingList}?site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: MEETING_HISTORY, payload: data.response.data.resultSets });
    return data.response.data.resultSets;
  }
};

export const getPocList = (siteId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.pocList}?site_id=${siteId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: POC_LIST_DROPDOWN, payload: data.response.data });
    return data.response.data;
  }
};

export const createMeeting = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.installation.createMeeting
  );
  if (res?.data?.response?.status === true) {
    return true;
  }
};

export const getMeetingById = (meetingId) => async (dispatch) => {
  const res = await callWebService(
    callTypes.get,
    '',
    `${Config.installation.meetingById}?meeting_id=${meetingId}`
  );
  if (res) {
    const { data } = res;
    dispatch({ type: MEETING_BY_ID, payload: data.response.data });
    return data.response.data;
  }
};

export const cancelMeeting = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.installation.cancelMeeting
  );
  if (res?.data?.response?.status === true) {
    return true;
  }
  if (res?.data?.response?.status === false) {
    store.dispatch({
      type: SHOW_HIDE_TOAST,
      payload: { isToast: true, toastMessage: res?.data?.message },
    });
  }
};

export const completeMeeting = (requestData) => async () => {
  const res = await callWebService(
    callTypes.post,
    requestData,
    Config.installation.completeMeeting
  );
  if (res?.data?.response?.status === true) {
    return true;
  }
};
